import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MUITabs from '@material-ui/core/Tabs';
import MUITab from '@material-ui/core/Tab';

import { PrintBox } from '../../Base';
import { COLOR } from '../../Theme';

const StyledMUITabs = withStyles(theme => ({
  root: {
    // flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${COLOR.tabGrey}`,
  },
  indicator: {
    // backgroundColor: COLOR.white,
    // transition: 'none',

    backgroundColor: COLOR.primary,
  },
}))(MUITabs);

const Tab = withStyles(theme => ({
  root: {
    fontFamily: 'inherit', // RBTheme.fonts.sans,
    borderBottom: '2px solid transparent',
    '@media(max-width: 511px)': {
      flexGrow: 1,
    },
  },
  label: {
    fontSize: 14,
  },
  labelContainer: {
    '@media(max-width: 511px)': {
      padding: '0 6px',
    },
  },
  textColorInherit: {
    color: COLOR.greyscale.grey1,
  },
  selected: {
    color: COLOR.primary,
    borderBottom: '2px solid',

    // border: `1px solid ${COLOR.tabGrey}`,
    // borderBottomColor: 'white',
    // borderRadius: '4px 4px 0 0',
  },
}))(MUITab);

class Tabs extends React.Component {
  state = {
    value: this.props.value !== undefined ? this.props.value : this.props.initValue,
  };

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        component: PropTypes.node,
      })
    ),
    onChange: PropTypes.func,
    hideOnPrint: PropTypes.bool,
    value: PropTypes.number,
    initValue: PropTypes.number,
  };

  static defaultProps = {
    items: [],
    initValue: 0,
  };

  handleChange = (event, value) => {
    if (this.props.value !== undefined) this.setState({ value });
    this.props.onChange(value);
  };

  render() {
    const { items, hideOnPrint } = this.props;
    const { value } = this.state;

    return (
      <Fragment>
        <PrintBox display={hideOnPrint && 'none'}>
          <StyledMUITabs value={value} onChange={this.handleChange}>
            {items.map(tab => (
              <Tab key={tab.label} label={tab.label} href={tab.href} />
            ))}
          </StyledMUITabs>
        </PrintBox>
        {items.length ? items[value].component : null}
        {/* {value === 0 && <div>Item One</div>}
        {value === 1 && <div>Item Two</div>}
        {value === 2 && <div>Item Three</div>} */}
      </Fragment>
    );
  }
}

export default Tabs;
